import catalog from './events.catalog.json';

import { AnalyticsEvent } from './events.constants.generated';
import type { AnalyticsEventPayloadMap } from './events.property-types.generated';

export { AnalyticsEvent };
export type { AnalyticsEventPayloadMap };

export type AnalyticsPropertySchema =
  | { readonly type: 'string' }
  | { readonly type: 'number' }
  | { readonly type: 'boolean' }
  | { readonly type: 'enum'; readonly values: readonly string[] };

export type AnalyticsEventDefinition = {
  readonly event: string;
  /** Plain-language summary for PMs, analysts, and agents (not sent to analytics providers). */
  readonly description: string;
  readonly properties: Readonly<Record<string, AnalyticsPropertySchema>>;
};

export type AnalyticsEventCatalog = {
  readonly [module: string]: {
    readonly [key: string]: AnalyticsEventDefinition;
  };
};

/** Single source of truth for event names and documented properties. */
export const analyticsEventCatalog = catalog as AnalyticsEventCatalog;

export type AnalyticsEventName = keyof AnalyticsEventPayloadMap & string;
